/* wsapi3-login-options v1.0 */
/* Deploy Version 2026-09-29 09:00:59 */
/* Deploy Version 2026-09-24 19:11:11 */
/* Deploy Version 2026-07-27 16:11:02 */
wsMain.createModule({
  name: 'login-options',
  version: '1.0',
  updatedAt: '2026-07-14',
  function: 'get',
  get() {
    return wsMain.modules['login-options'].create();
  },
  create() {
    let userName = document.querySelector('#HD_LVCLI_NOME')?.value || null;
    let shopId = document.querySelector('#HD_LV_ID')?.value;

    // HD_LVCLI_NOME agora sempre existe no DOM (fallback 'Visitante' server-side para o
    // widget de reviews), então esse valor sentinela precisa ser tratado como "sem nome"
    // para não bloquear o fallback via localStorage de sessões sem cookie de cliente.
    if (userName === 'Visitante') userName = null;

    if (!userName) {
      try {
        const session = JSON.parse(localStorage.getItem('ws_customer_session') || 'null');
        if (session?.customer?.name) userName = session.customer.name;
      } catch(e) {}
    }

    userName = userName || 'Visitante';

    // Exibição ("Olá, {{value}}") mostra só o primeiro nome — trim() antes do split
    // cobre o nome vindo com espaço acidental no início.
    let displayName = userName !== 'Visitante' ? userName.trim().split(' ')[0] : userName;

    let container = document.querySelector('[data-wsjs-login="container"]');
    let options = wsMain.tools.getWsData(container, 'options');

    try {
      if (options.float == false) {
        container.classList.add('lateral-list');
        if (typeof nPanel == 'undefined') {
          container.querySelector('[data-wsjs-login="button"]').addEventListener('click', () => {
            wsMain.modules['login-options'].open();
          });
    
          document.addEventListener('keydown', (event) => {
            if(event.key == 'Escape') wsMain.modules['login-options'].open(true);
          });          
        }
      }
  
      container.style.opacity = "1";
    } catch(err) {}

    if (userName != 'Visitante') {
      document.querySelectorAll('[data-wsjs-login]').forEach(item => {
        let attr = item.getAttribute('data-wsjs-login');
        if (attr == 'container') item.classList.add('logged');
        if (attr == 'list-register') item.remove();
        if (attr == 'logout') item.setAttribute('href', `/logoff/${shopId}/logoff`);
        if (attr == 'username') item.innerHTML = item.innerHTML.replace('{{value}}', displayName);
        if (attr != 'list-register') item.removeAttribute('data-wsjs-login');
        if (attr == 'favorite' && typeof WsFavoritos == 'undefined') item.remove();

        wsMain.addons.dataLoad(item);
      });
    } else {
      document.querySelectorAll('[data-wsjs-login]').forEach(item => {
        let attr = item.getAttribute('data-wsjs-login');
        if (attr == 'logout' || attr == 'username' || attr == 'list-login') item.remove();
        if (attr == 'container') item.classList.add('not-logged');
        else if (attr != 'list-login') item.removeAttribute('data-wsjs-login');
        if (attr == 'favorite' && typeof WsFavoritos == 'undefined') item.remove();

        wsMain.addons.dataLoad(item);
      });

      // Sem sessão: clique no menu de usuário abre a sidebar de identificação/login
      // (wsapi3-login-sidebar) em vez do dropdown de hover — que só faz sentido pra
      // quem já está logado (Meus Dados/Meus Pedidos/Sair). O dropdown de hover fica
      // escondido pra esse estado via .not-logged no CSS deste módulo. `container`
      // pode ser null em páginas sem o header padrão (ex.: /checkout usa
      // wsapi3-checkout-header em vez de topo.html).
      let loginBtn = container && container.querySelector('.login-options-button');
      if (loginBtn && !loginBtn.dataset.loginSidebarBound) {
        loginBtn.dataset.loginSidebarBound = '1';
        loginBtn.addEventListener('click', (e) => {
          e.preventDefault();
          if (wsMain.modules['login-sidebar']) wsMain.modules['login-sidebar'].open();
        });
      }
    }

    return true;

  },
  open(vrf) {
    const body = document.querySelector('body'),
      list = document.querySelector('.login-options-container.lateral-list .login-options-list'),
      overlay = document.querySelector('[data-wsjs-cart="overlay-holder"]')

    if (list.style.right == '0px' || vrf) {
      body.style.left = '';
      body.style.overflow = '';
      list.style.right = ''
      overlay.setAttribute('style', 'width: 0;height: 0;opacity:0');
    } else {
      list.style.right = '0'
      body.style.overflow = 'hidden';
      body.style.left = '-48rem';
      overlay.setAttribute('style', 'width: 100%;height: 100%;opacity:0.8')
    }
  }
})
